import React, { useContext } from 'react';
import PageLayout from '../../pagelayout';
import * as css from '../../dashboard/dashboard.module.scss';
import { useLoader } from '../../api/useLoader';
import { AdminApiContext } from '../../api/AdminApiContext';
import { TableCell, TableRow } from '@mui/material';
import StandardTable from '../../components/table';
import { useIntl } from 'react-intl';
import Spinner from '../../components/spinner/spinner';
import Button from '../../components/button';
import translations from './synkronisering.i18n';
import { HttpError } from '../../api/generated/admin-generated-api';
import { uuidv4 } from '../../util/uuidv4';
import {
  AlpNotificationType,
  NotificationFunctionContext,
} from '../../components/notifications/notificationProvider';

const Synkronisering = () => {
  const { brukerApi } = useContext(AdminApiContext);
  const { addNotification } = useContext(NotificationFunctionContext);
  const { data, loading, reload } = useLoader(() => brukerApi.fssyncGet(), []);
  const { formatMessage } = useIntl();

  const syncSuccess = formatMessage({ id: translations.syncSuccess.id });
  const title = formatMessage({ id: translations.title.id });
  const subtitle = formatMessage({ id: translations.subtitle.id });

  const startSyncOn = (jobbtype: string, reload: () => void) => {
    brukerApi
      .fssyncJobbtypePut({
        pathParams: {
          jobbtype: jobbtype,
        },
      })
      .then(() => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.SUCCESS,
          message: syncSuccess,
        });
        reload();
      })
      .catch((err: HttpError) => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.ERROR,
          message: err.body,
        });
      });
  };

  const startSyncAll = (reload: () => void) => {
    brukerApi
      .fssyncPut()
      .then(() => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.SUCCESS,
          message: syncSuccess,
        });
        reload();
      })
      .catch((err: HttpError) => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.ERROR,
          message: err.body,
        });
      });
  };

  const syncButtonText = formatMessage({ id: translations.syncButtonText.id });
  const syncAllButtonText = formatMessage({
    id: translations.syncAllButtonText.id,
  });
  const refreshButtonText = formatMessage({
    id: translations.refreshButtonText.id,
  });

  const tableHeaders = [
    { title: formatMessage({ id: translations.syncname.id }) },
    { title: formatMessage({ id: translations.numberoferrors.id }) },
    { title: formatMessage({ id: translations.nestekjoring.id }) },
    { title: formatMessage({ id: translations.sistevellykket.id }) },
    { title: formatMessage({ id: translations.action.id }) },
  ];

  const tableRows = data?.map((data) => (
    <TableRow key={data.jobbtype}>
      <TableCell>{data.jobbtype}</TableCell>
      <TableCell>{data.antallFeil}</TableCell>
      <TableCell>{new Date(data.nesteKjoring).toLocaleString()}</TableCell>
      <TableCell>
        {data.sisteVellykket && new Date(data.sisteVellykket).toLocaleString()}
      </TableCell>
      <TableCell>
        {
          <Button.Secondary onClick={() => startSyncOn(data.jobbtype, reload)}>
            {syncButtonText}
          </Button.Secondary>
        }
      </TableCell>
    </TableRow>
  )) || [<></>];

  return (
    <PageLayout isIndented title={title} subtitle={subtitle}>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <StandardTable headers={tableHeaders} rows={tableRows} />
          <div className={css.buttonContainer}>
            <Button.Secondary onClick={() => startSyncAll(reload)}>
              {syncAllButtonText}
            </Button.Secondary>
            <Button.Secondary
              onClick={() => {
                reload();
              }}
            >
              {refreshButtonText}
            </Button.Secondary>
          </div>
        </>
      )}
    </PageLayout>
  );
};

export default Synkronisering;
